/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Period_Preset_AriaInputs */

const vi_order_period_preset_aria = /** @type {(inputs: Order_Period_Preset_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn nhanh khoảng thời gian`)
};

/**

* @param {Order_Period_Preset_AriaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_period_preset_aria = /** @type {((inputs?: Order_Period_Preset_AriaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Period_Preset_AriaInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_period_preset_aria(inputs)
});